import { Stock } from './stock.model';
import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';

@Injectable({ providedIn: 'root' })

export class StockService extends BaseService<Stock>{

    constructor(
        protected injector:Injector,
    ){
        super(injector);
        this.copyJsonDataToObjectFunction=Stock.fromJsonToObject
        this.urls={
            getAllUrl:'stocks',
            saveUrl:'regStock',
            updateUrl:'up-stock',
            deleteUrl:'dst-stock',
            updateImageWithNoDataUrl:'up-imagens-stock',
            updateIndividualImage:'up-imagem-stock'
        }
    }

}